import router from '../src/router'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useLoadingStore } from '@/store/loading'
import pinia from '@/store'
import { useUserStore } from '@/store/user'
import { useMenuStore } from '@/store/menu'
import { useSettingStore } from '@/store/setting'
import { useAppStore } from '@/store/app'
import {
  HALL_PRO_PUBLIC_PATH,
  HALL_APP_NAME,
  HALL_ACTIVE_RULE,
  HALL_DEV_PORT,
  SYSTEM_APP_NAME,
  SYSTEM_PRO_PUBLIC_PATH,
  SYSTEM_ACTIVE_RULE,
  SYSTEM_DEV_PORT,
} from '../../../micro/config.js'

const reuseTabStore = useReuseTabStore(pinia)
const lodingStore = useLoadingStore(pinia)
const userStore = useUserStore(pinia)
const menuStore = useMenuStore(pinia)
const settingStore = useSettingStore(pinia)
const appStore = useAppStore(pinia)

export const state = {
  userInfo: {},
  token: '',
  action: 0,
  loading: false,
  menus: [],
  reuseTabSource: [],
  buttons: [],
}

export const commonProps = {
  parentRouter: router as any,
  state,
  reuseTabStore,
  lodingStore,
  userStore,
  menuStore,
  settingStore,
  appStore,
}
export const apps = [
  {
    name: HALL_APP_NAME, //子应用的名称
    entry: process.env.NODE_ENV === 'production' ? HALL_PRO_PUBLIC_PATH : `//localhost:${HALL_DEV_PORT}`, //子应用的域名
    container: '#hall-micro-container', //承载子应用的容器，在上面App.vue中定义
    activeRule: HALL_ACTIVE_RULE, // 被激活的子应用的路由
    props: {
      baseRoute: HALL_ACTIVE_RULE,
      ...commonProps,
    },
  },
  {
    name: SYSTEM_APP_NAME, //子应用的名称
    entry: process.env.NODE_ENV === 'production' ? SYSTEM_PRO_PUBLIC_PATH : `//localhost:${SYSTEM_DEV_PORT}`, //子应用的域名
    container: '#mainlayout-micro-container', //承载子应用的容器，在上面App.vue中定义
    activeRule: SYSTEM_ACTIVE_RULE, // 被激活的子应用的路由
    props: {
      baseRoute: SYSTEM_ACTIVE_RULE,
      ...commonProps,
    },
  },
]
const excludeAsserts = ['https://qiyukf.com', 'amap.com']
export function excludeAssetFilter(url) {
  return excludeAsserts.includes(url)
}
